module.exports = __webpack_public_path__ + "static/media/my-account-bg.75a2814b.jpg";